import { type FunctionComponent } from 'react';
import cn from 'classnames';
import { VStack } from '@direct-frontend/components';
import { renderIsland } from './lib/renderIsland';
import { useMobileView } from '../../../../lib/platform';
import { ErrorBlankSad, ErrorBlankSpinner } from '../../../ErrorBlank';
import { ErrorBlankTears } from '../../../ErrorBlank';
import { StatusWrapper } from '../../../StatusWrapper';
import { GridLayoutWrapper } from '../GridLayoutWrapper';
import GridPageLayoutDesktop from './GridPageLayout@desktop';
import { type GridPageLayoutComponentProps } from './types';
import styles from './GridPageLayout@mobile.module.css';

const GridPageLayout: FunctionComponent<GridPageLayoutComponentProps> = (props) => {
    const showMobileView = useMobileView();

    if (!showMobileView) {
        return <GridPageLayoutDesktop {...props} />;
    }

    const {
        queryStatus,
        header,
        contentRef,
        containerRef,
        children,
        isEmpty,
        renderEmpty,
        renderEmptyIslandContent,
        isError,
        renderError,
        renderErrorIslandContent,
        isFetching,
        renderFetching,
        renderFetchingIslandContent,
        containerClassName,
        contentClassName,
    } = props;

    const fetching = () =>
        renderIsland({
            fullRender: renderFetching,
            renderContent: renderFetchingIslandContent,
            content: <ErrorBlankSpinner title="Идёт загрузка информации для отображения страницы..." />,
            islandContainerClassName: styles.islandContainer,
            islandClassName: styles.island,
        });

    const error = () =>
        renderIsland({
            fullRender: renderError,
            renderContent: renderErrorIslandContent,
            content: <ErrorBlankTears title="На странице что-то пошло не так" />,
            islandContainerClassName: styles.islandContainer,
            islandClassName: styles.island,
        });

    const empty = () =>
        renderIsland({
            fullRender: renderEmpty,
            renderContent: renderEmptyIslandContent,
            content: <ErrorBlankSad title="На странице нет данных" />,
            islandContainerClassName: styles.islandContainer,
            islandClassName: styles.island,
        });

    return (
        <StatusWrapper
            queryStatus={queryStatus}
            isError={isError}
            renderError={error}
            isEmpty={isEmpty}
            renderEmpty={empty}
            isFetching={isFetching}
            renderFetching={fetching}
        >
            <VStack ref={containerRef} gap="8" className={cn(styles.container, containerClassName)}>
                {Boolean(header) && <div>{header}</div>}
                <GridLayoutWrapper contentRef={contentRef} contentClassName={cn(contentClassName)}>
                    {children}
                </GridLayoutWrapper>
            </VStack>
        </StatusWrapper>
    );
};

export default GridPageLayout;
